/** @format */

import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import UpdateIcon from '@mui/icons-material/Update';
import PaidIcon from "@mui/icons-material/Paid";
import Chip from "@mui/material/Chip";
import { toast } from 'react-toastify';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useNavigate } from "react-router-dom";
import SelectDate from "./SelectDate";
import axios from "axios";
import { useState } from "react";

dayjs.extend(customParseFormat);

function AddUpdatePaymentDetails({
  shippingId,
  paymentDt = false,
  paymentReceivedDt = false,
  shippingPaymentDetails,
  editMode = false,
}) {
  console.log(shippingPaymentDetails);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [paymentDate, setPaymentDate] = React.useState(() => {
    if (!paymentDt) {
      return null;
    } else {
      return dayjs(paymentDt, "DD/MM/YYYY");
    }
  });
  const [paymentReceivedDate, setPaymentReceivedDate] = React.useState(() => {
    if (!paymentReceivedDt) {
      return null;
    } else {
      return dayjs(paymentReceivedDt, "DD/MM/YYYY");
    }
  });

  async function submitPaymentDetails(data) {
    setLoading(true)
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/shipment/form-2/${shippingId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(response);
      setLoading(false)
      navigate("/shipment-and-payment-list");
      toast.success(`Payments Details successfully submitted`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
    } catch (err) {
      setLoading(false)
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
      console.log(err);
    }
  }

  async function updatePaymentDetails(data) {
    setLoading(true)
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/v1/shipment/form-2/${shippingId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(response);
      setLoading(false)
      navigate("/shipment-and-payment-list");
      toast.success(`Payments Details successfully updated`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
    } catch (err) {
      setLoading(false)
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
      console.log(err);
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    console.log(shippingId);
    const paymentData = {
      paymentDt: data.get("payment-date"),
      paymentReceivedDt: data.get("payment-received-date"),
    };
    editMode
      ? updatePaymentDetails(paymentData)
      : submitPaymentDetails(paymentData);
  }
  return (
    <>
      <Box
        sx={{
          marginTop: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "500px",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <PaidIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {editMode ? "Update Payment Details" : "Add Payment Details"}
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            mt: 1,
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <SelectDate
            dateLabel="Payment Date"
            dateName="payment-date"
            value={paymentDate}
            onChange={setPaymentDate}
          />

          <SelectDate
            dateLabel="Payment Received Date"
            dateName="payment-received-date"
            value={paymentReceivedDate}
            onChange={setPaymentReceivedDate}
          />
          <Typography sx={{ mt: 4, mb: 2 }}>
            Payment Delayed By :{" "}
            {paymentDate === null ? (
              <Typography color="#FF0000" variant="span">
                Not Yet Paid
              </Typography>
            ) : (
              <Typography color="primary" variant="span">
                {paymentDate.diff(shippingPaymentDetails?.balDueDt, "d")} Days
              </Typography>
            )}
          </Typography>
          <Typography sx={{ my: 2 }}>
            Payment Delayed Overdue :{" "}
            {paymentDate === null ? (
              <Typography color="#FF0000" variant="span">
                {dayjs().diff(shippingPaymentDetails?.balDueDt, "d")} Days
              </Typography>
            ) : (
              <Typography color="primary" variant="span">
                Paid
              </Typography>
            )}
          </Typography>
          <Typography sx={{ my: 2 }}>
            Net Amount Accrued :{" "}
            {
              <Typography color="primary" variant="span">
                {Math.abs(
                  shippingPaymentDetails?.invoiceValue -
                    shippingPaymentDetails?.balDue
                )}{" "}
                <Chip
                  color="primary"
                  label={shippingPaymentDetails?.invoiceCurrency}
                />
              </Typography>
            }
          </Typography>
          <Typography sx={{ my: 2 }}>
            Net Amount Outstanding :{" "}
            {
              <Typography color="primary" variant="span">
                {shippingPaymentDetails?.balDue}{" "}
                <Chip
                  color="primary"
                  label={shippingPaymentDetails?.invoiceCurrency}
                />
              </Typography>
            }
          </Typography>
          {editMode ? (
            <LoadingButton
              type="submit"
              variant="contained"
              loading={loading}
              endIcon={<UpdateIcon />}
              loadingPosition="end"
              sx={{ mt: 3, mb: 2, bgcolor: "secondary.main" }}
            >
              Update
            </LoadingButton>
          ) : (
            <LoadingButton
              type="submit"
              variant="contained"
              loading={loading}
              endIcon={<SendIcon />}
              loadingPosition="end"
              sx={{ mt: 3, mb: 2, bgcolor: "secondary.main" }}
            >
              submit
            </LoadingButton>
          )}
        </Box>
      </Box>
    </>
  );
}

export default AddUpdatePaymentDetails;
